import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "./api";
import { AppThunk } from "./app";
import API_URL from "../config/ApiUrl";
import { apiUrls } from "./apiUrls";

interface commonState {
  status: [];
  privilegesList: [];
  rolesList: [];
  raceList: [];
  veteranStatusList: [];
  certificationsList: [];
  careersList: [];
  educationTrainingList: [];
  educationLevelsList: [];
  experienceList: [];
  generalQuestion: [];
  occupationalGroups: [];
  careersCategory: [];
  CareerPath: [];
  SkillCategory: [];
  viewLoading: any;
  editLoading: any;
  assessmentResultLoading: any;
  userList: [],

}

const initialState = {
  status: [],
  privilegesList: [],
  rolesList: [],
  raceList: [],
  veteranStatusList: [],
  certificationsList: [],
  generalQuestion: [],
  careersList: [],
  educationTrainingList: [],
  educationLevelsList: [],
  experienceList: [],
  occupationalGroups: [],
  careersCategory: [],
  CareerPath: [],
  SkillCategory: [],
  viewLoading: [false, null],
  editLoading: [false, null],
  assessmentResultLoading: [false, null, null],
  userList: [],

} as commonState;

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    setPrivilegesList: (state, action: PayloadAction<any>) => {
      state.privilegesList = action.payload;
    },
    setRolesList: (state, action: PayloadAction<any>) => {
      state.rolesList = action.payload;
    },
    setRaceList: (state, action: PayloadAction<any>) => {
      state.raceList = action.payload;
    },
    setVeteranStatusList: (state, action: PayloadAction<any>) => {
      state.veteranStatusList = action.payload;
    },
    setCertificationsList: (state, action: PayloadAction<any>) => {
      state.certificationsList = action.payload;
    },
    setCareersList: (state, action: PayloadAction<any>) => {
      state.careersList = action.payload;
    },
    setEducationTrainingList: (state, action: PayloadAction<any>) => {
      state.educationTrainingList = action.payload;
    },
    setEducationLevelsList: (state, action: PayloadAction<any>) => {
      state.educationLevelsList = action.payload;
    },
    setExperienceList: (state, action: PayloadAction<any>) => {
      state.experienceList = action.payload;
    },
    setOccupationalGroups: (state, action: PayloadAction<any>) => {
      state.occupationalGroups = action.payload;
    },
    setcareersCategory: (state, action: PayloadAction<any>) => {
      state.careersCategory = action.payload;
    },
    setgeneralQuestion: (state, action: PayloadAction<any>) => {
      state.generalQuestion = action.payload;
    },
    setCareerPath: (state, action: PayloadAction<any>) => {
      state.CareerPath = action.payload;
    },
    setSkillCategory: (state, action: PayloadAction<any>) => {
      state.SkillCategory = action.payload;
    },
    setEditLoading: (state, action: PayloadAction<any>) => {
      state.editLoading = action.payload;
    },
    setViewLoading: (state, action: PayloadAction<any>) => {
      state.viewLoading = action.payload;
    },
    setAssessmentResultLoading: (state, action: PayloadAction<any>) => {
      state.assessmentResultLoading = action?.payload;
    },
    setUserList: (state, action: PayloadAction<any>) => {
      state.userList = action.payload;
    },
  },
});

export const {
  setStatus,
  setPrivilegesList,
  setRolesList,
  setRaceList,
  setSkillCategory,
  setCareerPath,
  setcareersCategory,
  setVeteranStatusList,
  setCertificationsList,
  setgeneralQuestion,
  setCareersList,
  setEducationTrainingList,
  setEducationLevelsList,
  setExperienceList,
  setOccupationalGroups,
  setEditLoading,
  setViewLoading,
  setAssessmentResultLoading,
  setUserList,
} = commonSlice.actions;

export const fetchPrivilegesList = (): AppThunk<any> => async (dispatch) => {
  try {
    const response = await api.get(API_URL.COMMON.PRIVILEGES);
    dispatch(setPrivilegesList(response.data));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setPrivilegesList([]));
    return Promise.reject(error.data);
  }
};

export const fetchRolesList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.rolesList(payload));
        dispatch(setRolesList(response.data?.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setRolesList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchRaceList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.raceList(payload));
        const customizeObject = response.data.data?.sort((a: any, b: any) => b.id - a.id)
        dispatch(setRaceList(customizeObject));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setRaceList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchSkillCategory =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.skillcategory(payload));
        dispatch(setSkillCategory(response.data?.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setRaceList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchVeteranStatusList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.veteranStatusList(payload));
        const customizeObject = response.data.data?.sort((a: any, b: any) => b.id - a.id)

        dispatch(setVeteranStatusList(customizeObject));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setVeteranStatusList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchCertificationsList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.certificationsList(payload));
        const result: any = response.data?.data;
        dispatch(setCertificationsList(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setCertificationsList([]));
        return Promise.reject(error.data);
      }
    };
export const fetchCareersList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.careersList(payload));
        const result: any = response.data?.data;
        dispatch(setCareersList(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setCareersList([]));
        return Promise.reject(error.data);
      }
    };
export const fetchCareerPath =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.careerPath(payload));
        const result: any = response.data?.data;
        dispatch(setCareerPath(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setCareerPath([]));
        return Promise.reject(error.data);
      }
    };
export const fetchEducationTrainingList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.educationTrainingList(payload));
        const result: any = response.data?.data;
        dispatch(setEducationTrainingList(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setEducationTrainingList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchEducationLevelsList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.educationLevelsList(payload));
        const result: any = response.data?.data;
        dispatch(setEducationLevelsList(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setEducationLevelsList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchCareercategory =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.careerCategory(payload));
        const result: any = response.data?.data;
        dispatch(setcareersCategory(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setcareersCategory([]));
        return Promise.reject(error.data);
      }
    };

export const fetchGeneralQuestions =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.generalQuestion(payload));
        const result: any = response.data?.data;
        dispatch(setgeneralQuestion(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setgeneralQuestion([]));
        return Promise.reject(error.data);
      }
    };

export const fetchExperienceList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.experienceList(payload));
        const result: any = response.data?.data;
        dispatch(setExperienceList(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setExperienceList([]));
        return Promise.reject(error.data);
      }
    };

export const fetchOccupationalGroups =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.occupationalGroups(payload));
        const result: any = response.data?.data;
        dispatch(setOccupationalGroups(result));
        return Promise.resolve(result);
      } catch (error: any) {
        dispatch(setOccupationalGroups([]));
        return Promise.reject(error.data);
      }
    };

export const fetchWebUserList = (): AppThunk<any> => async (dispatch) => {
  try {
    const response = await api.get(API_URL.COMMON.WEBUSERS);
    dispatch(setUserList(response.data));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setUserList([]));
    return Promise.reject(error.data);
  }
};

const commonReducer = commonSlice.reducer;
export default commonReducer;
